import React from "react";
import { Button, Icon } from "semantic-ui-react";

const DownloadButton = (props) => {
  const size = props.caption ? (props.size ?? "small") : (props.size ?? "mini");

  return (
    <Button
      compact={props.compact || false}
      color="teal"
      {...props}
      icon={!props.caption}
      size={size}
      loading={props.loading || false}
      disabled={props.disabled || false}
      onClick={props.onClick}
      className={props.className}
      floated={props.floated}
    >
      <Icon name="download" /> {props.caption}
    </Button>
  );
};

export default DownloadButton;
